export interface IPromoProduct {
  id: number;
  position: number;
  offerType: TPromoProductOfferType;
  extra: {
    type: EPromoProductType;
  };
}

export enum EPromoProductType {
  Discount = 'discount',
  Mortgage = 'mortgage',
  Bonus = 'bonus',
  MilitaryMortgage = 'military_mortgage',
  MaternalCapital = 'maternal_capital',
  CianMortgage = 'cian_mortgage',
}

export type TPromoProductOfferType = 'promo';
